/* eslint-disable  */

import { getSiblings, closeSiblingsDropdown } from './utils';

export default class DropdownCheckboxes {
  selectText = 'Select';

  selectLabelText = '';

  selectButton = document.createElement('button');

  selectLabelEl = document.createElement('label');

  closeButtonEl = document.createElement('button');

  filterWrapperEl;

  checkboxesWrapperEl;

  constructor(selector, label) {
    this.filterWrapperEl = document.querySelector(selector);
    this.checkboxesWrapperEl = this.filterWrapperEl.querySelector('fieldset.js-form-wrapper');
    this.selectLabelText = label;

    if (this.filterWrapperEl) {
      this.init();
    }
  }

  init() {
    this.createDropdown();
    this.toggleCheckboxes();
    this.showCheckedValues();
    this.updateDropdownOnCheckboxChange();
  }

  createDropdown() {
    this.selectLabelEl.classList.add('form-item__label');
    this.selectLabelEl.innerText = this.selectLabelText;

    this.selectButton.classList.add('button-select');
    this.selectButton.innerText = this.selectText;

    this.filterWrapperEl.appendChild(this.selectLabelEl);
    this.filterWrapperEl.appendChild(this.selectButton);

    this.closeButtonEl.classList.add('close-dropdown');
    this.closeButtonEl.innerText = '✕';

    this.checkboxesWrapperEl.prepend(this.closeButtonEl);
  }

  toggleCheckboxes() {
    this.selectButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      document.querySelector('.nice-select.open')?.classList.remove('open');

      // close others dropdown

      const siblings = getSiblings(this.filterWrapperEl);
      closeSiblingsDropdown(siblings);

      this.selectButton.classList.toggle('active');
      this.checkboxesWrapperEl.classList.toggle('active');
    });

    window.addEventListener('click', (event) => {
      if (this.checkboxesWrapperEl.isEqualNode(event.target)) {
        return;
      }

      if (event.target.closest('.js-form-wrapper')?.isEqualNode(this.checkboxesWrapperEl)) {
        return;
      }

      if (!this.selectButton.isEqualNode(event.target)) {
        this.checkboxesWrapperEl.classList.remove('active');
        this.selectButton.classList.remove('active');
      }
    });

    this.closeButtonEl.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      this.checkboxesWrapperEl.classList.remove('active');
      this.selectButton.classList.remove('active');
    });
  }

  showCheckedValues() {
    const checkedItems = this.checkboxesWrapperEl.querySelectorAll(
      '.js-form-type-checkbox input[checked="checked"]:not([value="all"]) ',
    );

    if (checkedItems.length > 0) {
      if (checkedItems.length === 1) {
        this.selectButton.innerText = checkedItems[0].parentElement.querySelector('label')?.innerText;
      } else {
        this.selectButton.innerText = `${checkedItems[0].parentElement.querySelector('label')?.innerText} (+ ${
          checkedItems.length - 1
        })`;
      }
    } else {
      this.selectButton.innerText = 'Select';
    }
  }

  updateDropdownOnCheckboxChange() {
    const checkboxes = this.checkboxesWrapperEl.querySelectorAll('.js-form-type-checkbox input:not([value="all"]) ');

    if (!checkboxes.length > 0) return;

    const checkedItems = Array.from(
      this.checkboxesWrapperEl.querySelectorAll('.js-form-type-checkbox input[checked="checked"]:not([value="all"]) '),
    );

    let checkedValues = [];

    checkedItems.forEach((item) => {
      const obj = {
        value: item.value,
        label: item.parentElement.querySelector('label')?.innerText,
      };
      checkedValues.push(obj);
    });

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', (event) => {
        const obj = {
          value: checkbox.value,
          label: checkbox.parentElement.querySelector('label')?.innerText,
        };
        if (event.currentTarget.checked) {
          checkedValues.push(obj);
        } else {
          checkedValues = checkedValues.filter((item) => item.value !== obj.value);
        }

        // update dropdown text

        if (checkedValues.length > 0) {
          if (checkedValues.length === 1) {
            this.selectButton.innerText = checkedValues[0].label;
          } else {
            this.selectButton.innerText = `${checkedValues[0].label} (+ ${checkedValues.length - 1})`;
          }
        } else {
          this.selectButton.innerText = 'Select';
        }
      });
    });
  }
}

window.addEventListener('load', () => {
  const serviceFilter = document.querySelector('#services-wrapper');
  const locationFilter = document.querySelector('#locations-wrapper');

  if (serviceFilter) {
    const serviceSelect = new DropdownCheckboxes('#services-wrapper', 'Service');
  }

  if (locationFilter) {
    const locationSelect = new DropdownCheckboxes('#locations-wrapper', 'Location');
  }
});
